import classNames from 'classnames';

import { buttonElement } from './ButtonElement.css';
import type { ButtonElementProps } from './ButtonElement.types';

export function ButtonElement({
  children,
  type = 'button',
  disabled = false,
  onClick,
  variant = 'default',
  className,
}: ButtonElementProps) {
  return (
    <button
      type={type}
      disabled={disabled}
      className={classNames(
        buttonElement[variant],
        'rounded-md text-sm py-2 px-3 leading-5 font-medium',
        variant !== 'flush' && 'shadow-sm',
        className,
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
